import { useState, useEffect, useContext } from "react";
import { useQuery } from "react-query";
import { Row, Col } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faStar } from "@fortawesome/free-regular-svg-icons";

import { UserContext } from "../Contexts";
import { ProgressInfo, HomeCard, HomeStatisticBar, HomeCMSNotice, HomeSidebar } from "../Components";
import { SurveyService, ConfigService } from "../Services";
import { ProcessStatusEnum, QuestionnairesEnum } from "../Constants";
import { useToast } from "../Hooks";
import {
  formReportIcon,
  autoanalyseIcon,
  firstModuleIcon,
  secondModuleIcon,
  additionalOfferIcon,
  contractIcon,
} from "../images/icons";

function Home() {
  const { showError } = useToast();
  const { user } = useContext(UserContext);

  const [isDisableModule2, setIsDisableModule2] = useState(false);
  const [isDisableModule2SecondContract, setIsDisableModule2SecondContract] = useState(false);
  const [surveyTypes, setSurveyTypes] = useState(null);
  const [isOrderInfo, setIsOrderInfo] = useState(false);

  useQuery("deadlinesData", () => ConfigService.getDeadlinesFormattedToContext(user),
    {
      onSuccess: (response) => {
        const contractRecruitmentTypes = user.contractRecruitmentTypes;
        const contractMap = { "1": "First", "2": "Second" };

        Object.entries(contractRecruitmentTypes).forEach(([contractKey, type]) => {
          const contractName = contractMap[contractKey];
          const typeName = type.charAt(0).toUpperCase() + type.slice(1);

          const isNotInScope = !response[`is${contractName}Contract${typeName}InDeadlineScope`];
          const isEnabled = response[`is${contractName}Contract${typeName}DeadlineEnabled`];

          if (contractKey === "1") {
            setIsDisableModule2(isNotInScope && isEnabled);
          } else if (contractKey === "2") {
            setIsDisableModule2SecondContract(isNotInScope && isEnabled);
          }
        });
      },
      onError: () => {
        showError("Wystąpił błąd podczas pobierania terminów zamówień i umów.");
      },
    }
  );

  const isTypeActive = (type) => {
    const foundObject = surveyTypes?.find(
      (obj) => obj.type === type && obj.activate === true
    );

    return !!foundObject;
  };

  useEffect(() => {
    if (!!surveyTypes && !!user && user.currentStep >= ProcessStatusEnum.CompletingBalanceSheetOfModuleSecond.value) {
      SurveyService.fetchAnswers(user.id, surveyTypes[2].questionnaire_id)
        .then((response) => {
          parseInt(response.data.complete_pages) > 1 && setIsOrderInfo(true);
        })
        .catch((error) => {
          console.error(error);
        });
    }
  }, [user, surveyTypes]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        await SurveyService.fetchTypes()
          .then((response) => {
            setSurveyTypes(response.data);
            const motivator = response.data.find((obj) => {
              return obj.type === 1;
            });
            return motivator.days_to_complete;
          })
          .catch((error) => {
            console.error(error);
          });
      } catch (error) {
        console.error(error);
      }
    };
    fetchData();
  }, []);

  return (
    <Row className="home-container hom-con m-0">
      <Col lg={3} className="home-progress-container">
        <HomeSidebar />
      </Col>
      <Col lg={9} className="home-main-container text-center">
        {user.currentStep === ProcessStatusEnum.CompletingBalanceSheetOfModuleSecond.value && isOrderInfo && !isDisableModule2 && (
          <Row className="mx-1 mb-4">
            <div className="application-form-container survey-screen fullwidth">
              <div className="info-container">
                <div className="description-element">
                  <FontAwesomeIcon
                    icon={faStar}
                    className="description-icon"
                  />
                  <div class="description-paragraph" data-id="33:4107">
                    <div>
                      Został Ci jeden krok do zamówienia bonów. Kliknij "Zamów
                      bony" w module "Twój cel rozwojowy"
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </Row>
        )}

        <Row className="mx-3 mb-4">
          <Col className="m-0 p-0" lg={6}>
            <HomeCMSNotice />
          </Col>
          <Col className="m-0 p-0" lg={6}>
            <HomeStatisticBar />
          </Col>
        </Row>

        <Row className="home-card-grid mx-1">
          {!user.isFirstRecrutation && (
            <Col>
              <HomeCard
                label="Formularz zgłoszeniowy"
                image={formReportIcon}
                navigateTo="/ApplicationForm"
              />
            </Col>
          )}

          {[
            {
              label: "Autoanaliza",
              image: autoanalyseIcon,
              navigateTo: "/survey",
              disabled: !user.isSurveyActive,
            },
            {
              label: "Samoocena",
              image: firstModuleIcon,
              navigateTo:
                user.currentStep > ProcessStatusEnum.Store.value
                  ? "/StoreSummary"
                  : "/CompletingBalanceSheetOfModuleFirst",
              disabled:
                user.currentStep < ProcessStatusEnum.CompletingBalanceSheetOfModuleFirst.value ||
                user.currentStep === ProcessStatusEnum.CompletingBalanceSheetOfModuleFirstByAdvisor.value,
            },
            {
              label: "Moje spotkania",
              image: additionalOfferIcon,
              navigateTo: "/meetings",
              disabled: false,
            },
            {
              label: "Twój cel rozwojowy",
              image: secondModuleIcon,
              navigateTo: "/CompletingBalanceSheetOfModuleSecond",
              disabled:
                isDisableModule2 ||
                user.currentStep < ProcessStatusEnum.CompletingBalanceSheetOfModuleSecond.value ||
                user.currentStep === ProcessStatusEnum.EndWithoutOrder.value ||
                !isTypeActive(QuestionnairesEnum.Module2.value) ||
                (user.fromReserveList && !user.consentToVouchers),
            },
            {
              label: "Umowa o dofinansowanie",
              image: contractIcon,
              navigateTo: "/ContractForm",
              disabled:
                user.currentStep < ProcessStatusEnum.OrderingVouchers.value ||
                user.currentStep === ProcessStatusEnum.OrderingVouchers.value ||
                user.currentStep === ProcessStatusEnum.EndWithoutOrder.value,
            },
            {
              label: "Twój cel rozwojowy - drugie zamówienie",
              image: secondModuleIcon,
              navigateTo: "/CompletingBalanceSheetOfModuleSecondv2",
              disabled:
                isDisableModule2SecondContract ||
                user.currentStep < ProcessStatusEnum.CompletingBalanceSheetOfModuleSecondv2.value ||
                user.currentStep === ProcessStatusEnum.EndWithoutOrder.value ||
                !user.isSecondOrderAvailable||
                (user.fromReserveList && !user.consentToVouchers),
            },
            {
              label: "Druga umowa o dofinansowanie",
              image: contractIcon,
              navigateTo: "/ContractFormv2",
              disabled: user.currentStep < ProcessStatusEnum.ContractFormv2.value,
            },
          ].map((card, index) => {
            return (
              <Col key={index}>
                <HomeCard
                  label={card.label}
                  image={card.image}
                  navigateTo={card.navigateTo}
                  disabled={card.disabled}
                />
              </Col>
            )
          })}
        </Row>
      </Col>
    </Row>
  );
}

export default Home;
